import type { DestructuredScenario } from "@/composables/useDestructureScenario";
import type { MaybeRef } from "@vueuse/core";
import type { Feet, Meters } from "@/libs/units/length";

export type SurveyExportRow = {
  section: string;
  label: string;
  targetUnit: typeof Feet | typeof Meters | null;
  value: MaybeRef<string | number | undefined | null>;
  disableConversion?: boolean;
  decimalPlaceOverride?: number;
  overrideLabel?: { newLabel: string; labelToReplace: string };
}[];

export enum ThreeDSurveyColumns {
  MeasuredDepth = "Measured Depth",
  Inclination = "Inclination (Degrees)",
  Azimuth = "Azimuth (Degrees)",
  TrueVerticalDepth = "True Vertical Depth",
  DoglegSeverity = "Dogleg Severity"
}

export enum TwoDSurveyColumns {
  MeasuredDepth = "Measured Depth",
  Inclination = "Inclination (Degrees)",
  TrueVerticalDepth = "True Vertical Depth"
}

export type TargetSurveyExportUnits = {
  exportUnits: typeof Feet | typeof Meters;
};

export type RenderSurveyExportCols = (props: {
  scenario: DestructuredScenario;
  targetUnits: TargetSurveyExportUnits;
}) => SurveyExportRow;
